import { render } from "./HeaderTrangChu.vue?vue&type=template&id=01dfe92c&scoped=true"
import script from "./HeaderTrangChu.vue?vue&type=script&lang=js"
export * from "./HeaderTrangChu.vue?vue&type=script&lang=js"

import "./HeaderTrangChu.vue?vue&type=style&index=0&id=01dfe92c&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01dfe92c"]])

export default __exports__